import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface ICampaignVerifyUseCase {
    execute(username: string, language: string, otp: string, apiToken?: { [key: string]: string }): Promise<any>;
}

export class CampaignVerifyUseCase implements ICampaignVerifyUseCase {
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    async execute(username: string, language: string, otp: string, apiToken?: { [key: string]: string }): Promise<any> {
        return await this.subscriptionRepository.campaignVerify(username, language, otp, apiToken);
    }
}
